import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import ShowMoreButton from './show-more-button';

class ShowMore extends Component {
    constructor(props) {
        super(props);
    }

    handleToggleShowMore(linkEl) {
        if (this.props.expand === true) {
            this.props.onCollapse(linkEl);
        } else {
            this.props.onExpand(linkEl);
        }
    }

    render() {
        let className = cx({
            "show-more": true,
        })

        className = `${className} ${this.props.className}`;

        let style = {
            height: this.props.expand ? '100%' : ''
        }
        return (
            <div className={className}>
                <div className="children-container" style={style} >
                    { this.props.children }
                </div>
                <ShowMoreButton isExpanded={this.props.expand} onClick={this.handleToggleShowMore.bind(this)} />
            </div>
        )
    }
    static get propTypes() {
        return {
            "className": PropTypes.string,
            "numberOfItemsShown": PropTypes.number,
            "numberOfItemsExpand": PropTypes.number,
            "expand": PropTypes.bool,
            onCollapse: PropTypes.func,
            onExpand: PropTypes.func,
            children: PropTypes.any
        }
    }
    static get defaultProps() {
        return {
            "className": "",
            "numberOfItemsShown": 4,
            "numberOfItemsExpand": 4
        }
    }
}



export default ShowMore;